import { render, staticRenderFns } from "./Monster.vue?vue&type=template&id=78f4982b&scoped=true&"
import script from "./Monster.vue?vue&type=script&lang=js&"
export * from "./Monster.vue?vue&type=script&lang=js&"
import style0 from "./Monster.vue?vue&type=style&index=0&id=78f4982b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4982b",
  null
  
)

export default component.exports